import { PollWithResults } from '@core/types';
import { PollResult } from '../PollResult';

export const PollResults = ({ poll }: { poll: PollWithResults }) => {
    return (
        <ol className="min-h-0 overflow-y-auto px-0 py-2 z-10" data-testid="PollResults">
            {poll.options.map((option, index) => {
                return (
                    <PollResult
                        key={`poll-result-${index}`}
                        index={index}
                        answer={option.text}
                        totalVotes={poll.totalWeightedVotes}
                        votes={option.weightedVotes}
                    />
                );
            })}
        </ol>
    );
};
